var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.getLogin)?_c('v-btn',{attrs:{"text":"","to":"/login"}},[_vm._v(" Log In ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }